import { restApiFields, payloadContentTypeFields } from "layouts/Flow Designer/data/restApiFields";
import { sftpFields } from "layouts/Flow Designer/data/sftpFields";

export const appendRestAndWebhookFields = (
  field = {},
  value,
  formActionCopy = {},
  setActionForm = Function(),
  componentAction = {},
  setComponentAction = Function()
) => {
  switch (field) {
    case "authenticationType":
      if (value) {
        restApiFields[value]?.forEach((field) => {
          formActionCopy[field.field] = {
            value: "",
            isPassword: field.type === "password" ? true : false
          };
        });
        setActionForm(formActionCopy);
        setComponentAction({
          ...componentAction,
          dataInsideAction: componentAction.dataInsideAction.map((action) => {
            if (action.field === field) {
              return {
                ...action,
                listItems: [...action.listItems.slice(0, 1), ...restApiFields[value]]
              };
            }
            return action;
          })
        });
      } else {
        setComponentAction({
          ...componentAction,
          dataInsideAction: componentAction.dataInsideAction.map((action) => {
            if (action.field === field) {
              return {
                ...action,
                listItems: action.listItems?.slice(0, 1)
              };
            }
            return action;
          })
        });
      }
      break;
    case "payloadContentType":
      payloadContentTypeFields[value]?.forEach((field) => {
        formActionCopy[field.field] = {
          value: field.field === "formData" ? [] : ""
        };
      });
      setActionForm(formActionCopy);
      setComponentAction({
        ...componentAction,
        dataInsideAction: componentAction.dataInsideAction?.map((action) => {
          if (action.field === field) {
            return {
              ...action,
              listItems: [...(action.listItems?.slice(0, 1) ?? []), ...payloadContentTypeFields[value]]
            };
          }
          return action;
        })
      });
      break;
  }
};

export const appendSftpFields = (
  field,
  value,
  formActionCopy,
  setActionForm,
  componentAction,
  setComponentAction
) => {
  switch (field) {
    case "operation":
      if (value) {
        sftpFields[value]?.forEach((field) => {
          formActionCopy[field.field] = {
            value: formActionCopy[field.field]?.value || "",
            isPassword: field.type === "password" ? true : false
          };
        });
        const operationFieldIndex = componentAction.dataInsideAction.findIndex(
          (action) => action.field === field
        );

        let newDataInsideAction = [];
        setActionForm(formActionCopy);

        if (componentAction.isCredentialSupported) {
          newDataInsideAction = [
            ...(componentAction.dataInsideAction?.slice(0, operationFieldIndex + 1) ?? []),
            ...sftpFields[value],
            ...(componentAction.dataInsideAction?.slice(-1) ?? [])
          ];
        }
        setComponentAction({
          ...componentAction,
          dataInsideAction: newDataInsideAction
        });
      } else {
        setComponentAction({
          ...componentAction,
          dataInsideAction: [componentAction.dataInsideAction[0]]
        });
      }
      break;
  }
};
